export default __webpack_public_path__ + "static/media/interview.e5a8b86d.svg";